import { Link, useNavigate, Outlet } from "react-router-dom";
import useAuth from "../../context/User/useAuth";
import axios from "../../utils/axios";

function Header() {
  const { auth, setAuth } = useAuth();
  console.log(auth);
  const navigate = useNavigate();

  const logOutUser = async () => {
    try {
      const today = new Date();
      const date = today.toISOString();
      const data = await axios.post("employee/logout", {
        data: {
          date: date,
          empId: auth.employee._id.toString(),
          type: "logout",
        },
      });
      return data;
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <header>
        <div className="nav">
          <div className="card">
            <div
              className="logo"
              onClick={() => {
                if (window.location.pathname === "/") {
                  navigate(0);
                } else {
                  navigate("/");
                }
              }}
            >
              Home
            </div>
          </div>
          {auth.isAuthenticated ? (
            <>
              <div
                className="list-item"
                onClick={() => {
                  navigate("/timesheets");
                }}
              >
                {`${auth?.employee?.firstName} ${auth?.employee?.lastName}`}
              </div>
              <button
                onClick={async (e) => {
                  setAuth({
                    isAuthenticated: false,
                    employee: {
                      _id: "",
                      firstName: "",
                      lastName: "",
                      role: 0,
                      jobs: [],
                    }
                  });
                  await logOutUser();
                  navigate("/login");
                }}
              >
                <p className="btn-loginout">Logout</p>
              </button>
            </>
          ) : (
            <button>
              <Link to="/login">Login</Link>
            </button>
          )}
        </div>
      </header>
      <Outlet />
    </>
  );
}

export default Header;
